module.exports = __webpack_public_path__ + "img/infc_isifc.72eb22cb.png";